<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				:fill="color"
				clip-rule="evenodd"
				d="M5.5 2.5C3.84315 2.5 2.5 3.84315 2.5 5.5V19.5C2.5 21.1569 3.84315 22.5 5.5 22.5H19.5C21.1569 22.5 22.5 21.1569 22.5 19.5V5.5C22.5 3.84315 21.1569 2.5 19.5 2.5H5.5ZM5.74219 6.32812H10.0013L13.0381 10.3394L16.3609 6.40602H18.5448L14.0705 11.7026L14.0612 11.6908L19.2578 18.5548H14.9987L11.8242 14.3617L8.24914 18.5938H6.06523L10.792 12.9983L5.74219 6.32812ZM9.4191 7.49629H8.09316L15.5809 17.3866H16.9068L9.4191 7.49629Z"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgTwitter',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
